import React from 'react';
import PropTypes from 'prop-types';
import Link from './Link';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

const StyledList = styled.div`
  margin: 0 auto;
  margin-bottom: 40px;
  max-width: ${p => p.theme.globalWidthSmall};
  width: 100%;

  ${breakpoints.medium`
    margin-bottom: 50px;
  `};

  ${breakpoints.large`
    margin-bottom: 86px;
  `};
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px 10px;

  ${breakpoints.medium`
    grid-template-columns: repeat(${p => (p.columns ? p.columns : 3)}, 1fr);
  `};
`;

export const ListItem = styled.h2`
  border-bottom: 1px solid ${p => p.theme.colors.border};
  display: block;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
  padding-bottom: 10px;

  ${breakpoints.medium`
    font-size: 1.125rem;
  `};

  ${breakpoints.large`
    font-size: 1.125rem;
  `};
`;

export const Label = styled.span`
  font-weight: 700;
  line-height: 1.6;

  ${breakpoints.small`
        display: block;
  `};

  ${breakpoints.large`
    display: inline;
  `};
`;

export const Value = styled.span`
  font-weight: 500;
  line-height: 1.6;
`;

export const LinkListItem = styled(Link)`
  color: ${p => p.theme.colors.lightFont};
  cursor: pointer;
  border-bottom: 1px solid ${p => p.theme.colors.border};
  display: block;
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1;
  padding-bottom: 10px;
  text-decoration: none;
  transition: color 0.2s, border-color 1s;

  &:hover {
    color: ${p => p.theme.colors.darkFont};
    border-color: ${p => p.theme.colors.primary};
  }
`;

export default function List({ columns, children, className }) {
  return (
    <StyledList className={className}>
      <Content columns={columns}>{children}</Content>
    </StyledList>
  );
}

List.propTypes = {
  columns: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

List.defaultProps = {
  columns: 3
};
